<template>

    <a class="app-button-link"
            :disabled="disabled"
            :class="{'is-loading': loading, 'is-disabled': disabled}"
            :type="type"
            :style="style"
            @click="onClick">
        <span class="inner">
            <span class="text"><slot></slot></span>
            <span class="icon" v-if="icon" v-html="$icon(icon)"></span>
        </span>

        <span class="loader" v-if="loading" v-html="$icon('loader')"></span>

    </a>

</template>

<script>

    export default {

        props: {
            type: {
                type: String,
                default: 'submit'
            },
            disabled: Boolean,
            loading: Boolean,
            icon: String
        },

        data() {
            return {
                style: {
                    width: null,
                    height: null
                },
            }
        },

        mounted() {
            this.updateSize();
        },

        updated() {
            // this.updateSize();
        },

        watch: {
            loading() {
                if(this.loading) {
                    this.style.width = this.style.height;
                }

                else {
                    this.updateSize();
                }
            }
        },

        methods: {

            updateSize() {
                this.style = {
                    width: null,
                    height: null
                };

                setTimeout(() => {
                    this.style = {
                        width: this.$el.clientWidth + 1 + 'px',
                        height: this.$el.clientHeight + 1 + 'px'
                    }
                }, 405);
            },

            onClick() {
                if(this.disabled) {
                    return;
                }

                this.$emit('click');
            }

        },

        computed: {

        }

    }

</script>

<style lang="scss" scoped>

    .app-button-link {
        border-radius: 150px;
        margin: 0;
        border: 0;
        background-color: $primary-blue;
        font-size: 20px;
        font-weight: bold;
        color: $white;
        line-height: 1;
        cursor: pointer;
        box-shadow: 0 0 0 0 $deep-blue;
        transition: all 0.4s ease;
        outline: none;
        overflow: hidden;
        position: relative;

        .inner {
            display: flex;
            padding: 17px 44px;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            width: 100%;

        }

        .text {
            font-family: Assistant, sans-serif;
        }


        &:not(.is-disabled):not(.is-loading):hover {
            box-shadow: 0 4px 0 1px $navy-blue;
        }

        &:not(.is-disabled):active {
            background-color: rgba($primary-blue, 0.8);
            box-shadow: 0 0 0 3px $navy-blue !important;
        }
        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 22px;

            svg {
                display: block;
            }
        }

        &.is-loading {

            .inner {
                opacity: 0;
            }

        }

        &.is-disabled {
            background-color: $pale-blue;
            pointer-events: none;
            cursor: default;
        }

        .loader {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;

            ::v-deep svg {
                display: block;
                width: 100%;
                height: 100%;
            }
        }

    }

</style>
